<script>
export default {
    name: "Placeholder"
}
</script>

<template>
    <div>
        <div v-for="waiting in 3" :key="waiting" class="bg-white mb-4 rounded-lg shadow-sm p-4">
            <div class="d-flex align-items-center mb-3">
                <!-- Avatar placeholder -->
                <div class="border p-1 border-secondary rounded-circle">
                    <div class="bg-secondary blink" style="width: 50px; height: 50px;border-radius: 50%"></div>
                </div>
                <div class="ml-3 w-100">
                    <!-- Name placeholder -->
                    <div class="bg-secondary rounded w-25 blink" style="height: 10px;"></div>
                    <!-- Description placeholder -->
                    <div class="bg-secondary rounded w-75 mt-2 blink" style="height: 15px;"></div>
                </div>
            </div>
            <div class="mb-4 blink">
                <!-- Progress bar placeholder -->
                <div class="d-flex justify-content-between align-items-center">
                    <div v-for="i in 4" :key="i" class="ml-2 bg-secondary rounded-circle"
                         style="width: 15px; height: 15px;"></div>
                    <div class="bg-secondary rounded w-50" style="height: 10px;"></div>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <!-- Additional icons and text placeholders -->
                <div v-for="i in 3" :key="i" class="bg-secondary rounded w-25 blink" style="height: 10px;"></div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>